/* global axios */
import ApiClient from './ApiClient';

class CallsAPI extends ApiClient {
  constructor() {
    super('calls', { accountScoped: true });
  }

  // GET /api/v1/accounts/{accountId}/calls
  // Supported params: page, status, direction, inbox_id, agent_id, since, until
  getCalls(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CallsAPI();
